const supplementDetails = r => require(['@/views/roleStatistics/supplementDetails'], r) // 角色补人明细
const amDetails = r => require(['@/views/roleStatistics/amDetails'], r) // AM补全明细
const inspection = r => require(['@/views/roleStatistics/inspection'], r) // 活跃角色巡检
const statistics = r => require(['@/views/roleStatistics/statistics'], r) // 角色补人统计
const lackOfOneDetails = r => require(['@/views/roleStatistics/lackOfOneDetails'], r) // 角色缺人明细
const lackOfOneStatistics = r => require(['@/views/roleStatistics/lackOfOneStatistics'], r) // 角色缺人统计

export default [
  {
    path: "lackOfOneDetails",
    component: lackOfOneDetails,
    name: "lackOfOneDetails",
    meta: {auth: true,name: '角色补人'}
  },
  {
    path: "lackOfOneStatistics",
    component: lackOfOneStatistics,
    name: "lackOfOneStatistics",
    meta: {auth: true,name: '角色补人'}
  },
  {
    path: "statistics",
    component: statistics,
    name: "statistics",
    meta: {auth: true,name: '角色补人'}
  },
  {
    path: "inspection",
    component: inspection,
    name: "inspection",
    meta: {auth: true,name: '角色补人'}
  },
  {
    path: "amDetails",
    component: amDetails,
    name: "amDetails",
    meta: {auth: true,name: '角色补人'}
  },
  {
    path: "supplementDetails",
    component: supplementDetails,
    name: "supplementDetails",
    meta: {auth: true,name: '角色补人'}
  },
]



// WEBPACK FOOTER //
// ./src/router/roleStatistics.js